let account = {
    title: "账号安全",
    haveSet: "已设置",
    noSet: "未设置",
    isBind: "已绑定",
    noBind: "暂未绑定",
    activated: "已激活",
    nonactivated: "未激活",
    edit: "修改",
    set: "设置",
    bind: "绑定",
    activate: "激活",
    reset: "重置",
    noPhone: "为了验证您的身份，请先绑定手机号！",
    look: "查看",
    pghoess:"手机号",
    phonePlaceholder: "请输入手机号",
    phoneErr: "手机号格式错误，请重新输入",
    code: "验证码",
    codePlaceholder: "请输入验证码",
    typePlaceholder:"请选择令牌序列号",

    code6: "请输入6位数字的验证码",
    getCode: "获取验证码",
    offlineCode: "离线二维码",
    pwd: "密码",
    pwdPlaceholder: "请输入密码",
    ema: "邮箱",
    emailPlaceholder: "请输入邮箱",
    login: {
        title: "登录密码",
        text: "安全性高的密码可以使账号更安全，建议您定期更换密码。",
        editPwd: "修改密码",
        setPwd: "设置密码",
        affirmPwd: "确认密码",
        affirmPwdPlaceholder: "请输入确认密码",
        oldPwd: "原密码",
        newPwd: "新密码",
        newPwdPlaceholder: "请输入新密码",
        oldPwdMsg: "请输入原密码",
    },
    setting: {
        title: "多因素认证方式",
        text: "企业支持多种多因素认证方式，您可以在此查看更多信息。"
    },
    phone: {
        title: "绑定手机",
        tip01: "已绑定手机：",
        editPhone: "修改绑定手机",
        tip02: "绑定手机号，更有效的保障账号安全。",
        tip03: "为保证您的账号安全，请您及时绑定手机号。",
    },
    email: {
        title: "绑定邮箱",
        tip01: "已绑定邮箱：",
        editEmail: "修改邮箱",
        tip02: "绑定邮箱，更有效的保障账号安全。",
        tip03: "为保证您的账号安全，请您及时绑定邮箱。",
        msg: "请输入正确的邮箱格式",
        emailError:"邮箱格式错误"
    },
    hardware: {
        title: "OTP硬件令牌",
        tip01: "已绑定",
        unbind: "解绑令牌",
        binds:"绑定令牌",
        bind: "绑定",
        bindToken:"绑定OTP硬件令牌",
        unbindTabs: "解绑",
        tip02: "个令牌，您可以通过OTP硬件令牌获取动态口令，保证账号安全。",
        tip03: "绑定后，您可以通过OTP硬件令牌获取动态口令，保证账号安全。",
        num: "令牌序列号",
        numPlaceholder: "请输入令牌序列号",
        code: "动态口令",
        codePlaceholder: "请输入动态口令",
        typePlaceholder:"请选择令牌序列号",
        bindOrUnbind:"绑定/解绑令牌",
        bindOrUnbindOtp:"绑定/解绑OTP硬件令牌"
    },
    FIDOU2F: {
        title: "FIDO硬件令牌",
        tip01: "已绑定",
        tip02: "个令牌，您可以通过FIDO硬件令牌快速认证，保证账号安全。",
        tip03: "绑定后，您可以通过FIDO硬件令牌快速认证，保证账号安全。",
        deviceName: "设备名称",
        selectName: "请选择设备名称",
        devicePlaceholder: "请输入设备名称",
        device: "请插入FIDO硬件令牌设备，然后点击开始绑定按钮，待设备指示灯闪烁时轻按按键完成绑定！",
        unbind: "解绑令牌",
        device32: "设备名称长度不能超过32位",
        bind: "开始绑定",
        deviceErr: "绑定令牌已取消！",
        deviceRepetition: "令牌不允许重复绑定！",
        failure: "FIDO硬件令牌操作失败",
        bindSuccess: "绑定成功",
        bindOrUnbindFIDOU2f:"绑定/解绑FIDO硬件令牌",
        bindToken:"绑定FIDO硬件令牌",

    },
    dynamic: {
        title: "飞天云信令（OTP）",
        resetDynamic: "重置飞天云信令（OTP）",
        activateDynamic: "激活飞天云信令（OTP）",
        text: "激活后，您将可通过飞天云信令APP获取动态口令登录，或经推送认证快速登录，以保护账号安全。",
        tip01: "您已成功激活飞天云信令（OTP），您可以通过飞天云信令APP获取动态口令登录，或经推送认证快速登录。",
        tip02: "激活后，您将可通过飞天云信令APP获取动态口令登录，或经推送认证快速登录，以保护账号安全。",
        codeTitle: "扫描下方二维码，下载飞天云信令APP",
        newVersion: "若已安装，请确保为最新版本",
        comingSoon: "敬请期待",
        app: "APP已下载？切换",
        app2: "APP未下载？切换",
        code: "激活码",
        appCode: "打开云信令APP，点击“扫一扫”",
        activateCode: "扫描下方激活码，根据指示进行激活",
        downloadCode: "下载码",
        dynamicPwd: "验证动态口令：",
        placeholder: "请输入动态口令，非必填",
        tip: "注：手机无网状态下扫码激活时需验证口令,否则将无法上送激活状态！",
        subBtn: "完成",
        safetyVerification: "重置OTP动态口令，请先进行账号安全验证",
    },
    webAuthn: {
        title: "FIDO2（WebAuthn）身份验证器",
        text: "绑定后，您可以通过Windows Hello、Touch ID等身份验证器快速认证登录，保护账号安全。",
        unbind: "绑定/解绑身份验证器",
        bind: "绑定身份验证器",
        binds:"绑定",
        tip01: "已绑定",
        tip02: "个身份验证器，您可通过该身份验证器快速认证登录。",
        name: "身份验证器名称",
        unbindTab: "解绑",
        tokenName: "请选择身份验证器名称",
        extent: "身份验证器名称长度不能超过32位",
        noOpenMsg: "未开启Windows Hello,Touch ID绑定到平台的身份验证器",
        userErrMsg: "用户验证平台验证器时出错",
        nonsupportMsg: "不支持的网络协议",
        nonsupportWebAuthn: "这个浏览嚣不支持WebAuthn！.",
        httpsMsg: "WebAuthn仅支持安全连接",
        windowClose: "绑定window Hello 已取消！",
        repetitionBind: "FIDO2（WebAuthn）不允许重复绑定！",
        arouse: "已经唤起认证器！",
        operationFail: "操作失败",
        deviceExists: "FIDO2（WebAuthn）－身份认证器名称已存在",
        bindSuccess: "绑定成功",
    },
    FIDO: {
        title: "飞天云信令（FIDO）",
        resetFIDO: "重置飞天云信令（FIDO）",
        activateFIDO: "激活飞天云信令（FIDO）",
        text: "激活后，您将可通过飞天云信令APP的指纹或人脸认证秒速登录，以保护账号安全。",
        tip01: "您已成功激活飞天云信令（FIDO），您可以通过飞天云信令APP的指纹或人脸认证秒速登录。",
        safetyVerification: "重置飞天云信令（FIDO），请先进行账号安全验证"
    },
    fastLogin:{
        title:"飞天云信令FastLogin",
        text:"下载飞天云信令FastLogin客户端并与账号进行绑定，可一键登录门户，登录更加高效。",
        down:"下载"
    }
}

export default account
